import JobFindrData from "./projectData/jobFindrData";
import RemplrData from "./projectData/remplrData";
import RemplrVegData from "./projectData/remplrVegData";
import CurrencyConverter from "./projectData/currencyConverter";
import Jeopardy from "./projectData/jeopardy";
import Pathos from "./projectData/pathosData";
import EliteKitchenFindsData from "./projectData/EliteKitchenFindsData";
import CraftMyCardData from "./projectData/CraftMyCardData";
import BeyondSnackData from './projectData/BeyondSnackData'

const ProjectData = {
  remplr: RemplrData,
  "Job-Findr": JobFindrData,
  "remplr-veg": RemplrVegData,
  "currency-converter": CurrencyConverter,
  jeopardy: Jeopardy,
  pathos: Pathos,
  elitekitchenfinds: EliteKitchenFindsData,
  craftmycard: CraftMyCardData,
  beyondsnack: BeyondSnackData
};

export default ProjectData;
